import Container from "../components/Container";

import {useContext, useEffect, useState} from "react";
import AuthContext from "../utilis/contexts/AuthContext";
import ServiceCode from "../utilis/enums/ServiceCode";
import ReplyToInquiry from "../components/forms/ReplyToInquiry";
import MeterTest from "../components/forms/MeterTest";
import TemporaryDisconnectAndConnectBranch from "../components/forms/TemporaryDisconnectAndConnectBranch";
import ChangeSpecifications from "../components/forms/ChangeSpecifications"
import DeclareMeterConsumption from "../components/forms/DeclareMeterConsumption";
import BillingReview from "../components/forms/BillingReview";
import WasteWaterBranchAssignment from "../components/forms/WasteWaterBranchAssignment";
import ChangeAccountType from "../components/forms/ChangeAccountType"
import ChangeUnit from "../components/forms/ChangeUnit";
import ChangeCapacityContractualBranching from "../components/forms/ChangeCapacityContractualBranching";
import ChangeBranchDiameter from "../components/forms/ChangeBranchDiameter";
import SaleTankerWater from "../components/forms/SaleTankerWater"
import CollectOrMergeBranch from "../components/forms/CollectOrMergeBranch";
import MeterChange from "../components/forms/MeterChange";
import MidTermBill from "../components/forms/MidTermBill";
import InstallAdditionalSiphon from "../components/forms/InstallAdditionalSiphon";
import MoveMeasuringDevices from "../components/forms/MoveMeasuringDevices";
import WaterBranchAssignment from "../components/forms/WaterBranchAssignment";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import Texts from "../utilis/defaults/Text";
import {Button, Modal, notification} from "antd";
import Api from "../utilis/api/service";
import Urls from "../utilis/api/Urls";
import {AxiosError, AxiosResponse} from "axios";

import AppContext from "../utilis/contexts/AppContext";
import branchDefaultValue from "../utilis/models/branchDefaultValue";
import LocalStorage from "../utilis/tools/LocalStorage";
import {QuestionCircleOutlined} from "@ant-design/icons"
import Guide from "../components/modals/Guide";
import MeterSeparation from "../components/forms/MeterSeparation";
import serviceCode from "../utilis/enums/ServiceCode";

const FormSelector = () => {
    const navigate = useNavigate();
    window.scrollTo(0, 0)
    const {state,pathname} = useLocation();
    const [serviceName, setServiceName] = useState('')
    const authContext = useContext(AuthContext);
    const appContext = useContext(AppContext);
    const params = useParams();
    // @ts-ignore
    const [serviceType, setServiceType] = useState(authContext.authenticated ? params.serviceType : authContext.data.data.service_type)
    useEffect(()=>{
        setServiceType(params.serviceType)
        setTimeout(()=>handleRender(),30)
    },[params.serviceType])
    const [isOpen,setOpen]=useState(false);
    const [guideData,setGuideData]=useState<any>({
        url:'',
        tel_numbers:[]
    })
    const getName = () => {
        for (let code in ServiceCode) {

            // @ts-ignore
            if (ServiceCode[code] == params.serviceType) {

                // @ts-ignore
                setServiceName(Texts[code]);
                // @ts-ignore

            }
        }
    }
    const handleGuide=()=>{
        if (authContext.authenticated) {
            appContext.handleLoading(true)
            Api.post(Urls.GetGuideInformation, {
                Cellphone: authContext?.user?.cellphone,
                FileNumber:authContext.currentFileNumber,
                ServiceType:serviceType
            }, {
                headers: {
                    "Authorization": authContext.Token.tokenType + " " + authContext.Token.accessToken
                }
            }).then((response: AxiosResponse) => {

                const {data} = response;
                const {Status, Data, Message} = data;
                if (Status === 0) {
                    setOpen(true)
                    setGuideData(Data)
                }


            }).catch((e: AxiosError) => {

            }).finally(() => {
                appContext.handleLoading(false)
            })
        }

    }
    const Token=LocalStorage.getToken();
    useEffect(() => {
        getName();
        if (authContext.authenticated) {
            appContext.handleLoading(true)
            Api.post(Urls.GetBranchDefaultValues, {
                Cellphone: authContext.user.cellphone,
                BillId: authContext.currentBranchInfo.bill_id
            }, {
                headers: {
                    "Authorization": Token.token_type + " " + Token.access_token
                }
            }).then((response: AxiosResponse) => {

                const {data} = response;
                const {Status, Data, Message} = data;
                if (Status === 0) {
                    authContext.handleData(new branchDefaultValue(Data.branch_info));
                    LocalStorage.setData(Data.branch_info)
                }


            }).catch((e: AxiosError) => {
                console.log(e)
            }).finally(() => {
                appContext.handleLoading(false);
            })
        }
    }, [])
    const handleRender=()=>{
        getName();
        if (authContext.authenticated) {
            appContext.handleLoading(true)
            Api.post(Urls.GetBranchDefaultValues, {
                Cellphone: authContext.user.cellphone,
                BillId: authContext.currentBranchInfo.bill_id
            }, {
                headers: {
                    "Authorization": Token.token_type + " " + Token.access_token
                }
            }).then((response: AxiosResponse) => {

                const {data} = response;
                const {Status, Data, Message} = data;
                if (Status === 0) {
                    authContext.handleData(new branchDefaultValue(Data.branch_info));
                    LocalStorage.setData(Data.branch_info)
                }


            }).catch((e: AxiosError) => {

            }).finally(() => {
                appContext.handleLoading(false)
            })
        }
    }
    if (appContext.isLoading) {
        return <></>
    }
    const noDeptAffect=[serviceCode.SaleTankerWater,serviceCode.TemporaryDisconnectAndConnectBranch,serviceCode.WaterBranchAssignment,ServiceCode.BillingReview,ServiceCode.MidTermBill,ServiceCode.DeclareMeterConsumption]
    let isContain=false;
    Object.values(noDeptAffect).forEach((item:ServiceCode)=>{

        if("/panel/"+item.toString()===pathname){
            isContain=true;
        }
    })
    if(isContain){

    }else if(authContext.currentBranchInfo.has_debt) {
        navigate('/panel')
    }
    return <>

        {authContext.authenticated &&
            <div className="flex justify-center mb-3     w-full  items-center">
            <h1 className="text-lg font-bold w-full">   {`سرویس ${serviceName}`}</h1>

            <Button onClick={handleGuide} icon={        <QuestionCircleOutlined/>} type="link">راهنما</Button>
        </div>}
        {serviceType && serviceType === ServiceCode.ReplyToInquiry && <ReplyToInquiry/>}
        {serviceType && serviceType === ServiceCode.MeterTest && <MeterTest/>}
        {serviceType && serviceType === ServiceCode.TemporaryDisconnectAndConnectBranch &&
            <TemporaryDisconnectAndConnectBranch/>}
        {serviceType && serviceType === ServiceCode.ChangeSpecifications && <ChangeSpecifications/>}
        {serviceType && serviceType === ServiceCode.BillingReview && <BillingReview/>}
        {serviceType && serviceType === ServiceCode.DeclareMeterConsumption && <DeclareMeterConsumption/>}
        {serviceType && serviceType === ServiceCode.WasteWaterBranchAssignment && <WasteWaterBranchAssignment/>}
        {serviceType && serviceType === ServiceCode.ChangeAccountType && <ChangeAccountType/>}
        {serviceType && serviceType === ServiceCode.ChangeUnit && <ChangeUnit/>}
        {serviceType && serviceType === ServiceCode.ChangeCapacityContractualBranching &&
            <ChangeCapacityContractualBranching/>}
        {serviceType && serviceType === ServiceCode.ChangeBranchDiameter && <ChangeBranchDiameter/>}
        {serviceType && serviceType === ServiceCode.SaleTankerWater && <SaleTankerWater/>}
        {serviceType && serviceType === ServiceCode.CollectOrMergeBranch && <CollectOrMergeBranch/>}
        {serviceType && serviceType === ServiceCode.MeterChange && <MeterChange/>}
        {serviceType && serviceType === ServiceCode.MidTermBill && <MidTermBill/>}
        {serviceType && serviceType === ServiceCode.MeterSeparation && <MeterSeparation/>}
        {serviceType && serviceType === ServiceCode.InstallAdditionalSiphon && <InstallAdditionalSiphon/>}
        {serviceType && serviceType === ServiceCode.MoveMeasuringDevices && <MoveMeasuringDevices/>}
        {serviceType && serviceType === ServiceCode.WaterBranchAssignment && <WaterBranchAssignment orderType={serviceType} />}
       {/* {serviceType && serviceType === ServiceCode.WaterBranchAssignment && <WaterBranchAssignment orderType={serviceType} />}*/}
        <Modal footer={[ <Button key="back" className="w-full md:w-auto" onClick={()=>setOpen(false)}>
            بستن
        </Button>,]}  title="راهنما" open={isOpen}  onCancel={()=>setOpen(false)}>
        <Guide url={guideData.url} serviceType={serviceType} tels={guideData.tel_numbers}/>
        </Modal>
    </>

}
export default FormSelector;